import { render, staticRenderFns } from "./InfoParameter.vue?vue&type=template&id=70be9ccc&scoped=true&"
import script from "./InfoParameter.vue?vue&type=script&lang=js&"
export * from "./InfoParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70be9ccc",
  null
  
)

export default component.exports